/* unplugin-vue-components disabled */import { render } from "./courseArrange.vue?vue&type=template&id=0103abb6&scoped=true"
import script from "./courseArrange.vue?vue&type=script&lang=js"
export * from "./courseArrange.vue?vue&type=script&lang=js"

import "./courseArrange.vue?vue&type=style&index=0&id=0103abb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0103abb6"]])

export default __exports__